import React from "react";
import { Modal, Box, Typography } from "@mui/material";
import HealthDataForm from "../HealthDataForm/HealthDataForm";

interface HealthDataModalProps {
  open: boolean;
  onClose: () => void;
  memberId: string;
  latestHealthData: any;
  onDataSubmitted: () => void;
}

const HealthDataModal: React.FC<HealthDataModalProps> = ({
  open,
  onClose,
  memberId,
  latestHealthData,
  onDataSubmitted,
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >
        <Typography variant="h6" component="h2" gutterBottom>
          Update Health Metrics
        </Typography>
        <HealthDataForm
          memberId={memberId}
          latestHealthData={latestHealthData}
          onDataSubmitted={onDataSubmitted}
          onClose={onClose}
        />
      </Box>
    </Modal>
  );
};

export default HealthDataModal;
